<h2 class="page-heading">CTR Processing</h2>
<br>

<app-response-text
  [lambdaMessage]="lambdaMessage"
  [lambdaError]="lambdaError">
</app-response-text>

<div class="progress">
  <progress *ngIf="showProgressBar" [value]="contactsReprocessed" [max]="contactsTotal"></progress>
</div>

<br>
<br>

<div class="pageControls centerMe">
  <span>
    <span>Contact Id: </span>
    <input id="contactField" class="spaced" type="text" [(ngModel)]="contactId" (ngModelChange)="validate();" placeholder="Contact Id...">
    <button mat-raised-button color="primary" (click)="contactId = ''; tableData=[]; showTable=false; validate();">Clear</button>
  </span>
  <span class="centerMe">OR</span>
  <span class="centerMe">
    <button mat-raised-button color="primary" (click)="uploader.click();">Open File</button>
    <input hidden type="file" #uploader (change)="uploadFile($event)"/>
  </span>
</div>
<br>
<div class="centerMe">
  <button  mat-raised-button color="primary" (click)="readSingleContactRecord();" [disabled]="buttonsDisabled">Read</button>
  <button mat-raised-button color="primary" (click)="reprocessSingleContactRecord();" [disabled]="buttonsDisabled">Reprocess</button>
</div>
<br>

<div class="tableContainer" *ngIf="showTable">
  <!--grid-->
  <app-data-grid
    [(data)]="tableData"
    (itemChange)="handleEvent($event);"
    [(isValid)]="formValid"
    [viewTemplate]="view"
    [formTemplate]="formView"
    [columnNames]="['Contact ID', 'Claim ID', 'Start Time (sec)', 'End Time (sec)', 'Agent ID']"
    [spacing]="[3, 1.5, 1, 1, 2, 0.05]"
    [itemsPerPage]="itemsPerPage"
    [objectBluePrint]="bluePrint"
    [allowDelete]="false"
    [allowEdit]="!dataFromFile"
    [allowAdd]="false"
    >

    <ng-template #view let-item>
      <td>{{item.contactId}}</td>
      <td>{{getClaim(item)}}</td>
      <td>{{getStart(item)}}</td>
      <td>{{getEnd(item)}}</td>
      <td>{{getAgent(item)}}</td>
    </ng-template>

    <ng-template #formView let-item>
      <td>{{item.contactId}}</td>
      <td><input type="text" (focus)="includeProperty(item.Attributes, 'claimID');" (focusout)="removeEmptyProperties(item);" [(ngModel)]="item.Attributes.claimID" (ngModelChange)="validateItem(item.Attributes);"></td>
      <td><input type="text" (focus)="includeProperty(item.Attributes, 'startTime');" (focusout)="removeEmptyProperties(item);" [(ngModel)]="item.Attributes.startTime" (ngModelChange)="validateItem(item.Attributes);"></td>
      <td><input type="text" (focus)="includeProperty(item.Attributes, 'endTime');" (focusout)="removeEmptyProperties(item);" [(ngModel)]="item.Attributes.endTime" (ngModelChange)="validateItem(item.Attributes);"></td>
      <td><input type="text" (focus)="includeProperty(item.Attributes, 'agentUsername');" (focusout)="removeEmptyProperties(item);" [(ngModel)]="item.Attributes.agentUsername" (ngModelChange)="validateItem(item.Attributes);"></td>
    </ng-template>

  </app-data-grid>
  <br>

  <div class="centerMe">
    <button *ngIf="dataFromFile"  class="mat-button-wrapper" (click)="reprocessBatch();" [disabled]="tableButtonsDisabled">Reprocess</button>
    <button *ngIf="dataFromFile"  class="mat-button-wrapper" (click)="tableData=[]; showTable=false; validate();" [disabled]="tableButtonsDisabled">Cancel</button>
  </div>
  <br>

</div>

